export const integrations = {
  seo: {
    title: 'Integraties – koppel jouw favoriete apps | Bistroo',
    description: 'Koppel Lightspeed, Mollie, Exact en meer met één klik aan Bistroo. Bekijk alle beschikbare integraties voor jouw restaurant.',
  },
  hero: {
    heading: {
      1: 'Jouw',
      2: 'favoriete apps',
      3: 'geïntegreerd met één klik',
    },
    description: {
      1: 'We bieden een breed scala aan integraties zodat jij je kunt focussen op waar je goed in bent, zonder gedoe.',
      2: 'Onze integraties zorgen ervoor dat alles moeiteloos samenwerkt, zodat jij je kunt richten op het laten groeien van je bedrijf – niet op het beheren van technologie. Snelle installatie, soepele ervaring en geen gedoe.',
    },
  },
  cards: {
    card_1: {
      title: 'Kies je integratie',
      text: 'Selecteer je integratie uit onze app marketplace in de Bistroo manager.',
      button: 'Bekijk apps marketplace',
      img_alt: '',
    },
    card_2: {
      title: 'Volg de handleiding',
      text: 'We geven je de stappen die je moet volgen voor een soepel integratie proces.',
      button: '',
      img_alt: '',
    },
    card_3: {
      title: 'Activeer de integratie',
      text: 'Activeer de integratie in de Bistroo beheer-app en begin met het uitwisselen van data.',
      button: '',
      img_alt: '',
    },
    card_4: {
      title: 'Vragen?',
      text: 'Heb je vragen of wil je dat iemand even meekijkt met je integratie? Neem dan gerust contact met ons op.',
      button: '',
      img_alt: '',
    },
    card_5: {
      title: 'Je bent klaar om te starten!',
      text: 'Na het voltooien van deze stappen is je software volledig geïntegreerd.',
      button: '',
      img_alt: '',
    },
  },
  partner: {
    title: 'Ook partner worden?',
    text: {
      1: 'Meld je binnenkort aan via ons partner portaal. Tot die tijd, neem',
      2: 'contact met ons',
      3: 'op.',
    },
  },
}
